import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    headerContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    headerContent: {
        position: "absolute",
        left: 0,
        right: 0
    },
    headerTitle: {
        alignSelf: "center",
        maxWidth: "80%",
        textAlign: "center"
    },
    loadingContainer: {
        alignItems: "center",
        justifyContent: "center"
    },
    backButton: {
        alignSelf: "flex-start"
    },
    contentContainer: {
    },
    dialogHeaderContainer: {
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center"
    },
    dialogIconWrapper: {
        alignSelf: "center"
    },
    dialogTitle: {
        textAlign: "center"
    }
});
export default stylesheet;
